import React from "react";

const BlockHeader = ({ title, icon, subtitle }) => (
  <div
    style={{
      width: "100%",
      background: "linear-gradient(90deg, #f6815e 0%, #f6b93b 100%)",
      color: "#fff",
      padding: "38px 0 24px 0",
      textAlign: "center",
      marginBottom: 32,
      boxShadow: "0 4px 24px #f6815e22",
      position: "relative",
      overflow: "hidden",
    }}
  >
    <h1
      style={{
        fontWeight: 900,
        fontSize: "2.6rem",
        letterSpacing: 1,
        marginBottom: 11,
        textShadow: "0 2px 12px #f6815e55",
      }}
    >
      {title}
    </h1>
    <div style={{ fontSize: 20, fontWeight: 500, opacity: 0.96 }}>
      <span role="img" aria-label={title} style={{ marginRight: 8 }}>
        {icon}
      </span>
      {subtitle}
    </div>
  </div>
);

export default BlockHeader;
